import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Routes from "./Routes/Routes.js";
import Home from "./Home/Home.js";
import Cubes from "./Exercices/Cubes.js";
import Carres from "./Exercices/Carres.js";
import Puissance2 from "./Exercices/Puissance2.js";
import Puissance3 from "./Exercices/Puissance3.js";
import Table13 from "./Exercices/Table13.js";
import Table17 from "./Exercices/Table17.js";
import Table19 from "./Exercices/Table19.js";
import Racine from "./Exercices/Racine.js";
import Ratios from "./Exercices/Ratios.js";
import Favorites from "./Exercices/Favorites.js";
import Heures from "./Exercices/Heures.js";
import Parite from "./Exercices/Parite.js";
import Alphabet from "./Exercices/Alphabet.js";
import Divisibilite from "./Exercices/Divisibilite.js";
import Addition from "./Exercices/Addition.js";
import Soustraction from "./Exercices/Soustraction.js";
import Multiplication from "./Exercices/Multiplication.js";
import Pourcentage from "./Exercices/Pourcentage.js";
import Division from "./Exercices/Division.js";
import Rapports from "./Exercices/Rapports.js";

// function App() {
//   return (
//     <BrowserRouter>
//       <div>
//         <Routes />
//       </div>
//     </BrowserRouter>
//   );
// }

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Home />}></Route>
        <Route exact path="/cubes" element={<Cubes />} />
        <Route exact path="/carres" element={<Carres />} />
        <Route exact path="/table13" element={<Table13 />} />
        <Route exact path="/table17" element={<Table17 />} />
        <Route exact path="/table19" element={<Table19 />} />
        <Route exact path="/puissance2" element={<Puissance2 />} />
        <Route exact path="/puissance3" element={<Puissance3 />} />
        <Route exact path="/racine" element={<Racine />} />
        <Route exact path="/ratios" element={<Ratios />} />
        <Route exact path="/favorites" element={<Favorites />} />
        <Route exact path="/heures" element={<Heures />} />
        <Route exact path="/parite" element={<Parite />} />
        <Route exact path="/alphabet" element={<Alphabet />} />
        <Route exact path="/divisibilite" element={<Divisibilite />} />
        <Route exact path="/addition" element={<Addition />} />
        <Route exact path="/soustraction" element={<Soustraction />} />
        <Route exact path="/multiplication" element={<Multiplication />} />
        <Route exact path="/pourcentage" element={<Pourcentage />} />
        <Route exact path="/division" element={<Division />} />
        <Route exact path="/rapports" element={<Rapports />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
